function formatZipCode(zipCode: string): string;
function formatZipCode(zipCode: string | undefined): string | undefined;
function formatZipCode(zipCode: undefined): undefined;
function formatZipCode(zipCode: string | undefined): string | undefined {
    if (!zipCode?.length) return zipCode;
    const _zipCode = zipCode.trim();
    switch (_zipCode.length) {
        case 5:
            return `${_zipCode.substring(0, 3)} ${_zipCode.substring(3)}`;
        default:
            return _zipCode;
    }
}

export { formatZipCode };
